module.exports = __webpack_public_path__ + "img/webworthy-scene-1.fc8baac9.jpg";